var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "9l50wbzjza",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 10,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.706v-4.23h10V8.74c0 1.743-1.098 2.816-2.854 2.816H3.849C2.109 11.556 1 10.46 1 8.706zm2.755-1.367a.456.456 0 0 1-.472-.444c0-.255.198-.466.45-.478.247 0 .45.195.456.445a.456.456 0 0 1-.434.477zm2.256 0a.456.456 0 0 1-.472-.444c0-.255.198-.466.45-.478.247 0 .45.195.456.445a.456.456 0 0 1-.434.477zm2.24 2.045a.47.47 0 0 1-.456-.472.462.462 0 0 1 .45-.472h.005c.258 0 .467.211.467.472a.469.469 0 0 1-.467.472zM5.538 8.91c.01.256.22.456.472.445a.456.456 0 0 0 .434-.477.454.454 0 0 0-.456-.445.475.475 0 0 0-.45.477zm-2.262 0c.011.256.22.456.472.445a.456.456 0 0 0 .434-.477.454.454 0 0 0-.455-.445.475.475 0 0 0-.45.477zM7.8 6.89c0-.255.198-.46.45-.466.247 0 .445.2.456.444a.452.452 0 1 1-.906.028v-.006z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#9l50wbzjza)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1080FF",
    fillOpacity: 0.6,
    d: "M.506.444h10.648v11.358H.506z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.002 4.476c.007-.326.035-.973.086-1.181.264-1.172 1.158-1.917 2.437-2.023h4.95c1.268.112 2.174.861 2.438 2.023.05.202.078.855.085 1.181H1.002z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "dwchyzp7vb",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 10,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.002 4.476c.007-.326.035-.973.086-1.181.264-1.172 1.158-1.917 2.437-2.023h4.95c1.268.112 2.174.861 2.438 2.023.05.202.078.855.085 1.181H1.002z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dwchyzp7vb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1080FF",
    fillOpacity: 0.2,
    d: "M1 .938h10.648v3.549H1z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.369 2.567a.415.415 0 0 1-.423.428.415.415 0 0 1-.423-.428V.873c0-.245.182-.428.423-.428.242 0 .423.183.423.428v1.694zm4.105 0a.418.418 0 0 1-.423.428.415.415 0 0 1-.422-.428V.873c0-.245.18-.428.422-.428.236 0 .423.183.423.428v1.694z",
    fill: "url(#h086zf90hc)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ykjus7qrrd",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 6,
    height: 3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.369 2.567a.415.415 0 0 1-.423.428.415.415 0 0 1-.423-.428V.873c0-.245.182-.428.423-.428.242 0 .423.183.423.428v1.694zm4.105 0a.418.418 0 0 1-.423.428.415.415 0 0 1-.422-.428V.873c0-.245.18-.428.422-.428.236 0 .423.183.423.428v1.694z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ykjus7qrrd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#70B3FF",
    d: "M2.758-.265h6.389v3.549H2.758z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h086zf90hc",
    x1: 3.523,
    y1: 0.445,
    x2: 3.523,
    y2: 2.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalender);
export default __webpack_public_path__ + "static/media/ic_calender.598e108251cf9a57105d96e3c288c5a4.svg";
export { ForwardRef as ReactComponent };